// extracted by mini-css-extract-plugin
module.exports = {"msgLimit":"CreateSMS_msgLimit__1PYyo","patientName":"CreateSMS_patientName__2JtGE"};